export default "__VITE_ASSET__CH6W$V9p__"